import { apiClient } from './client'
import type { LoginCredentials, AuthResponse, CompleteNewPasswordRequest } from '@/types/auth'

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/login', credentials)
    return response.data
  },

  completeNewPassword: async (data: CompleteNewPasswordRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/complete-new-password', data)
    return response.data
  },

  verifyMFA: async (data: {
    email: string
    mfaCode: string
    session: string
  }): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/verify-mfa', data)
    return response.data
  },

  refresh: async (refreshToken: string): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/refresh', { refreshToken })
    return response.data
  },

  logout: async (): Promise<void> => {
    // Call backend logout endpoint if needed
    // await apiClient.post('/auth/logout')

    // Clear local storage
    localStorage.removeItem('auth_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('auth_user')
  },

}
